// extracted by mini-css-extract-plugin
module.exports = {"cls1":"footer-Links-module--cls1--2N9Os","narrow":"footer-Links-module--narrow--20v_q"};